module.exports = __webpack_public_path__ + "img/WV.5313269e.svg";